import { formatDaySeparator } from "../../lib/time";

export function DaySeparator({ ts }: { ts: number }) {
  return (
    <div style={{ display: "flex", justifyContent: "center", padding: "var(--space-md)" }}>
      <span
        style={{
          background: "var(--color-panel)",
          color: "var(--color-text-muted)",
          fontSize: "var(--font-size-sm)",
          padding: "4px 12px",
          borderRadius: "var(--radius-md)",
          boxShadow: "var(--shadow-sm)",
        }}
      >
        {formatDaySeparator(ts)}
      </span>
    </div>
  );
}
